/** @type {string} */
const scrollspyString = "scrollspy";
export default scrollspyString;
